module.exports = __webpack_public_path__ + "img/7.a363de9f.png";